module.exports = __webpack_public_path__ + "img/LX.ebfba5de.png";